// Product card swatches: hovering/focusing a swatch makes it the card's active
// variant (image, hover image and links) until another swatch is chosen
(function () {
  var swatchSelector = ".product-item__variant-swatch[data-swatch-image]";

  function setImage(img, url) {
    if (!img || !url) return;
    img.removeAttribute("srcset");
    img.removeAttribute("data-srcset");
    img.dataset.src = url;
    img.src = url;
  }

  function activate(swatch) {
    if (swatch.classList.contains("is-active")) return;
    var card = swatch.closest(".product-item");
    if (!card) return;

    card
      .querySelectorAll(".product-item__variant-swatch.is-active")
      .forEach((el) => el.classList.remove("is-active"));
    swatch.classList.add("is-active");

    setImage(
      card.querySelector(".product-item__image.first img"),
      swatch.dataset.swatchImage
    );
    setImage(
      card.querySelector(".product-item__image.not-first img"),
      swatch.dataset.swatchHoverImage
    );

    // Point the card at the chosen variant
    card
      .querySelectorAll(".product-item__image-wrapper, .product-item-title")
      .forEach((link) => link.setAttribute("href", swatch.getAttribute("href")));
  }

  function handle(e) {
    var swatch = e.target.closest && e.target.closest(swatchSelector);
    if (swatch) activate(swatch);
  }

  document.addEventListener("mouseover", handle);
  document.addEventListener("focusin", handle);
})();
